/* Schooner Supply — Club House Hanko shared behaviour.
   Loaded by the header section (status, hours, weather) and the FAQ section.
   Idempotent: safe to include more than once and re-runs in the Theme Editor. */
(function () {
  var DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  var LABELS = { mon: 'Maanantai', tue: 'Tiistai', wed: 'Keskiviikko', thu: 'Torstai', fri: 'Perjantai', sat: 'Lauantai', sun: 'Sunnuntai' };
  var ORDER = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

  function nowHelsinki() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Helsinki' })); }
  function toMin(t) { var p = t.split(':'); return (+p[0]) * 60 + (+p[1]); }
  function parseHours(raw) { try { return JSON.parse(raw || '{}'); } catch (e) { return {}; } }

  function initStatus(root) {
    (root || document).querySelectorAll('.ch-status').forEach(function (el) {
      if (el.dataset.chDone) return; el.dataset.chDone = '1';
      var hours = parseHours(el.dataset.chHours);
      var seasonStart = el.dataset.seasonStart, seasonEnd = el.dataset.seasonEnd;
      var now = nowHelsinki();
      var today = DAY_KEYS[now.getDay()];
      var dateStr = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
      var textEl = el.querySelector('.ch-status__text');
      var inSeason = (!seasonStart || dateStr >= seasonStart) && (!seasonEnd || dateStr <= seasonEnd);
      var ranges = inSeason ? (hours[today] || []) : [];
      var mins = now.getHours() * 60 + now.getMinutes();
      var open = false, closesAt = null, opensAt = null;
      ranges.forEach(function (r) {
        var s = toMin(r[0]), e = toMin(r[1]);
        if (mins >= s && mins < e) { open = true; closesAt = r[1]; }
        if (mins < s && opensAt === null) opensAt = r[0];
      });
      if (open) { el.classList.add('is-open'); textEl.textContent = 'Auki nyt · sulkeutuu klo ' + closesAt; }
      else {
        el.classList.add('is-closed');
        if (!inSeason) textEl.textContent = 'Kausi suljettu · verkkokauppa palvelee';
        else if (opensAt) textEl.textContent = 'Suljettu · avautuu klo ' + opensAt;
        else textEl.textContent = 'Suljettu tänään';
      }
    });
  }

  function initHoursTable(root) {
    (root || document).querySelectorAll('.ch-hours').forEach(function (box) {
      var hours = parseHours(box.dataset.chHours);
      var now = nowHelsinki();
      var todayKey = DAY_KEYS[now.getDay()];
      box.innerHTML = ORDER.map(function (k) {
        var r = hours[k] || [];
        var t = r.length ? r.map(function (x) { return x[0] + '–' + x[1]; }).join(', ') : 'Suljettu';
        var cls = k === todayKey ? ' ch-hours__row--today' : '';
        var name = LABELS[k] + (k === todayKey ? ' (tänään)' : '');
        return '<div class="ch-hours__row' + cls + '"><span>' + name + '</span><span>' + t + '</span></div>';
      }).join('');
    });
  }

  function initTodayCard(root) {
    var card = (root || document).querySelector('[data-ch-quick-today]');
    if (!card) return;
    var src = document.querySelector('[data-ch-hours]');
    if (!src) return;
    var hours = parseHours(src.dataset.chHours);
    var now = nowHelsinki();
    var today = DAY_KEYS[now.getDay()];
    var r = hours[today] || [];
    var fmt = function (t) { return t.replace(':00', ''); };
    var val = card.querySelector('.ch-quick__value');
    var sub = card.querySelector('.ch-quick__sub');
    if (r.length) {
      if (val) val.textContent = r.map(function (x) { return fmt(x[0]) + '–' + fmt(x[1]); }).join(', ');
    } else {
      if (val) val.textContent = 'Suljettu';
      var lbl = { mon: 'ma', tue: 'ti', wed: 'ke', thu: 'to', fri: 'pe', sat: 'la', sun: 'su' };
      for (var k = 1; k <= 7; k++) {
        var d = new Date(now); d.setDate(now.getDate() + k);
        var key = DAY_KEYS[d.getDay()];
        if ((hours[key] || []).length) { if (sub) sub.textContent = 'Avautuu ' + lbl[key] + ' klo ' + fmt(hours[key][0][0]); break; }
      }
    }
  }

  function initWeather(root) {
    (root || document).querySelectorAll('#ch-weather, .ch-weather').forEach(function (box) {
      if (box.dataset.chDone) return; box.dataset.chDone = '1';
      var place = box.dataset.place || 'Hanko';
      var start = new Date(new Date().getTime() - 3 * 3600 * 1000).toISOString().slice(0, 19) + 'Z';
      var FMI = 'https://opendata.fmi.fi/wfs?service=WFS&version=2.0.0&request=getFeature&storedquery_id=';

      // Parse FMI "simple" XML. ParameterName/ParameterValue are siblings inside
      // each BsWfsElement; newest value per parameter wins (rows are time-ascending).
      function latest(xml) {
        var doc = new DOMParser().parseFromString(xml, 'text/xml');
        var els = doc.getElementsByTagName('BsWfs:BsWfsElement');
        if (!els.length) els = doc.getElementsByTagNameNS('*', 'BsWfsElement');
        var out = {};
        for (var i = 0; i < els.length; i++) {
          var n = els[i].getElementsByTagName('BsWfs:ParameterName')[0] || els[i].getElementsByTagNameNS('*', 'ParameterName')[0];
          var v = els[i].getElementsByTagName('BsWfs:ParameterValue')[0] || els[i].getElementsByTagNameNS('*', 'ParameterValue')[0];
          if (!n || !v) continue;
          var vl = v.textContent;
          if (vl && vl !== 'NaN') out[n.textContent] = parseFloat(vl);
        }
        return out;
      }
      function setCell(metric, val, sub) {
        var c = box.querySelector('[data-ch-metric="' + metric + '"]'); if (!c) return;
        var v = c.querySelector('[data-ch-val]'); if (v && val != null) v.textContent = val;
        var s = c.querySelector('[data-ch-sub]'); if (s && sub != null) s.textContent = sub;
      }
      function dirFi(deg) {
        return ['Pohjoinen', 'Koillinen', 'Itä', 'Kaakko', 'Etelä', 'Lounas', 'Länsi', 'Luode'][Math.round(deg / 45) % 8];
      }
      function get(id, extra) { return fetch(FMI + id + '&starttime=' + start + extra).then(function (r) { return r.text(); }).then(latest); }
      var lat = parseFloat(box.dataset.lat || '59.823'), lon = parseFloat(box.dataset.lon || '22.969');
      // Low-precision solar elevation (deg) for a clear-sky UV estimate.
      function solarElevation(date) {
        var rad = Math.PI / 180, n = date.getTime() / 86400000 + 2440587.5 - 2451545.0;
        var g = ((357.529 + 0.98560028 * n) % 360) * rad;
        var q = (280.459 + 0.98564736 * n) % 360;
        var lambda = (q + 1.915 * Math.sin(g) + 0.020 * Math.sin(2 * g)) * rad;
        var eps = 23.439 * rad;
        var decl = Math.asin(Math.sin(eps) * Math.sin(lambda));
        var gmst = (18.697374558 + 24.06570982441908 * n) % 24; if (gmst < 0) gmst += 24;
        var ra = Math.atan2(Math.cos(eps) * Math.sin(lambda), Math.cos(lambda));
        var ha = (gmst * 15 + lon) * rad - ra;
        return Math.asin(Math.sin(lat * rad) * Math.sin(decl) + Math.cos(lat * rad) * Math.cos(decl) * Math.cos(ha)) / rad;
      }
      // FMI WeatherSymbol3 -> { line-icon name, Finnish text }
      function condFi(s) {
        var m = { 1: ['clear', 'Selkeää'], 2: ['partly-cloudy', 'Puolipilvistä'], 3: ['cloudy', 'Pilvistä'],
          21: ['showers', 'Sadekuuroja'], 22: ['showers', 'Sadekuuroja'], 23: ['showers', 'Voimakkaita kuuroja'],
          31: ['rain', 'Ajoittaista sadetta'], 32: ['rain', 'Sadetta'], 33: ['rain', 'Voimakasta sadetta'],
          41: ['snow', 'Lumikuuroja'], 42: ['snow', 'Lumikuuroja'], 43: ['snow', 'Voimakasta lunta'],
          51: ['snow', 'Lumisadetta'], 52: ['snow', 'Lumisadetta'], 53: ['snow', 'Voimakasta lunta'],
          61: ['thunder', 'Ukkoskuuroja'], 62: ['thunder', 'Voimakasta ukkosta'], 63: ['thunder', 'Ukkosta'], 64: ['thunder', 'Voimakasta ukkosta'],
          71: ['sleet', 'Räntäkuuroja'], 72: ['sleet', 'Räntää'], 73: ['sleet', 'Voimakasta räntää'],
          81: ['showers', 'Sadekuuroja'], 82: ['showers', 'Sadekuuroja'], 83: ['showers', 'Voimakkaita kuuroja'],
          91: ['fog', 'Utua'], 92: ['fog', 'Sumua'] };
        return { name: (m[s] || ['partly-cloudy'])[0], text: (m[s] || [null, 'Sää Hangossa'])[1] };
      }
      // Weather line icons (24×24, same Schooner pictogram style)
      var W_HI = 'M7.5 17.5h9a3.6 3.6 0 0 0 .35-7.18 4.8 4.8 0 0 0-9.2 1.05A3.3 3.3 0 0 0 7.5 17.5Z';
      var W_LO = 'M7.5 15h9a3.6 3.6 0 0 0 .35-7.18 4.8 4.8 0 0 0-9.2 1.05A3.3 3.3 0 0 0 7.5 15Z';
      var WEATHER = {
        'clear': '<circle cx="12" cy="12" r="4.2"/><path d="M12 2.5v2.4M12 19.1v2.4M2.5 12h2.4M19.1 12h2.4M5.3 5.3l1.7 1.7M17 17l1.7 1.7M18.7 5.3 17 7M7 17l-1.7 1.7"/>',
        'partly-cloudy': '<circle cx="8" cy="7.5" r="3"/><path d="M8 2v1.5M3.5 7.5H2M4.6 4.1 3.7 3.2M12.5 7.5h-1.1M11.4 4.1l.9-.9"/><path d="M10.5 19.5h7.2a3.4 3.4 0 0 0 .4-6.78 4.6 4.6 0 0 0-8.8 1.05 3.1 3.1 0 0 0 1.2 5.73Z"/>',
        'cloudy': '<path d="' + W_HI + '"/>',
        'rain': '<path d="' + W_LO + '"/><path d="M9 18v2.5M12 18v3M15 18v2.5"/>',
        'showers': '<path d="' + W_LO + '"/><path d="M9 18l-1 2.5M12.5 18l-1 3M16 18l-1 2.5"/>',
        'snow': '<path d="' + W_LO + '"/><path d="M9 18.5v.01M12 18v.01M15 18.5v.01M10.5 21v.01M13.5 21v.01"/>',
        'sleet': '<path d="' + W_LO + '"/><path d="M9.5 18v2M15 18.5v.01M12.5 20.5v.01"/>',
        'thunder': '<path d="M7.5 14.5h9a3.6 3.6 0 0 0 .35-7.18 4.8 4.8 0 0 0-9.2 1.05A3.3 3.3 0 0 0 7.5 14.5Z"/><path d="M12.5 12.5l-2.5 4.5h3l-2.5 4.5"/>',
        'fog': '<path d="M4 8.5h16M6 12h14M4 15.5h13M8 19h9"/>'
      };
      function wSvg(name) {
        return '<svg class="ch-svg-icon" viewBox="0 0 24 24" width="44" height="44" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (WEATHER[name] || WEATHER['partly-cloudy']) + '</svg>';
      }

      // 1. Weather station (temperature, wind, gusts, direction)
      get('fmi::observations::weather::simple', '&place=' + encodeURIComponent(place) + '&parameters=t2m,ws_10min,wg_10min,wd_10min')
        .then(function (d) {
          if (typeof d.t2m === 'number') { var t = box.querySelector('[data-ch-temp]'); if (t) t.textContent = Math.round(d.t2m) + '°'; }
          if (typeof d.ws_10min === 'number') {
            var dir = typeof d.wd_10min === 'number' ? ' ' + dirFi(d.wd_10min) : '';
            var gust = typeof d.wg_10min === 'number' ? ' · puuskat ' + Math.round(d.wg_10min) : '';
            var wtxt = box.querySelector('[data-ch-wind]'); if (wtxt) wtxt.textContent = 'Tuuli ' + Math.round(d.ws_10min) + ' m/s' + dir + gust;
            setCell('wind', Math.round(d.ws_10min) + ' m/s', typeof d.wg_10min === 'number' ? 'Puuskat ' + Math.round(d.wg_10min) + ' m/s' : (dir ? dir.trim() : null));
          }
          // Quick-info strip weather card (a sibling of the weather panel, same section)
          var qc = document.querySelector('[data-ch-quick-weather]');
          if (qc) {
            var qv = qc.querySelector('.ch-quick__value');
            if (qv && typeof d.t2m === 'number') qv.textContent = Math.round(d.t2m) + '°C';
            var qs = qc.querySelector('.ch-quick__sub');
            if (qs && typeof d.ws_10min === 'number') qs.textContent = 'Tuuli ' + Math.round(d.ws_10min) + ' m/s' + (typeof d.wd_10min === 'number' ? ' ' + dirFi(d.wd_10min) : '');
          }
        }).catch(function () {});

      // 2. Mareograph (water level from mean water, sea surface temperature)
      get('fmi::observations::mareograph::simple', '&place=' + encodeURIComponent(place))
        .then(function (d) {
          if (typeof d.WATLEV === 'number') { var cm = Math.round(d.WATLEV / 10); setCell('waterlevel', (cm >= 0 ? '+' : '') + cm + ' cm', 'MW-tasosta'); }
          if (typeof d.TW_PT1H_AVG === 'number') setCell('watertemp', Math.round(d.TW_PT1H_AVG) + '°C', 'Pintalämpö');
        }).catch(function () {});

      // 3. Wave buoy, Gulf of Finland (significant wave height)
      get('fmi::observations::wave::simple', '&bbox=21,58.5,25,60.5')
        .then(function (d) {
          if (typeof d.WaveHs === 'number') {
            var h = d.WaveHs, sea = h < 0.5 ? 'Tyyntä' : h < 1.25 ? 'Kohtalainen' : h < 2.5 ? 'Aika kova' : 'Kova';
            setCell('wave', h.toFixed(1).replace('.', ',') + ' m', sea);
          }
        }).catch(function () {});

      // 4. Forecast: visibility + weather symbol (condition). UV is estimated
      //    (clear-sky by solar elevation × cloud cover) because FMI's open
      //    forecast returns no UV index for this point.
      var hr = new Date(); hr.setUTCMinutes(0, 0, 0); var hz = hr.toISOString().slice(0, 19) + 'Z';
      fetch(FMI + 'fmi::forecast::harmonie::surface::point::simple&place=' + encodeURIComponent(place) + '&starttime=' + hz + '&endtime=' + hz + '&parameters=Visibility,WeatherSymbol3')
        .then(function (r) { return r.text(); }).then(latest).then(function (d) {
          if (typeof d.Visibility === 'number') {
            var km = Math.round(d.Visibility / 1000);
            setCell('visibility', km + ' km', km >= 20 ? 'Hyvä' : km >= 8 ? 'Kohtalainen' : km >= 1 ? 'Heikko' : 'Sumua');
          }
          var sym = d.WeatherSymbol3;
          if (typeof sym === 'number') {
            var c = condFi(sym);
            var ic = box.querySelector('.ch-weather__icon'); if (ic) ic.innerHTML = wSvg(c.name);
            var cd = box.querySelector('[data-ch-cond]'); if (cd && c.text) cd.textContent = c.text;
          }
          var cf = typeof sym === 'number' ? (sym <= 1 ? 1 : sym === 2 ? 0.85 : sym === 3 ? 0.6 : 0.4) : 0.85;
          var uvi = Math.max(0, Math.min(11, Math.round(8 * Math.pow(Math.max(0, Math.sin(solarElevation(new Date()) * Math.PI / 180)), 1.6) * cf)));
          setCell('uv', String(uvi), uvi <= 2 ? 'Matala' : uvi <= 5 ? 'Kohtalainen' : uvi <= 7 ? 'Korkea' : uvi <= 10 ? 'Erittäin korkea' : 'Äärimmäinen');
        }).catch(function () {});
    });
  }

  function bindFaqOnce() {
    if (window.__chFaqBound) return; window.__chFaqBound = true;
    document.addEventListener('click', function (e) {
      var q = e.target.closest ? e.target.closest('.ch-faq__q') : null;
      if (!q) return;
      var item = q.parentElement;
      var isOpen = item.classList.toggle('is-open');
      q.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function openAssistant() {
    var trig = document.querySelector('.dfd-chat-bubble-trigger') || document.querySelector('[aria-label="AI Assistant"]');
    if (trig) { trig.click(); return true; }
    return false;
  }
  function bindAssistantOnce() {
    if (window.__chAsstBound) return; window.__chAsstBound = true;
    document.addEventListener('click', function (e) {
      var card = e.target.closest ? e.target.closest('[data-ch-assistant]') : null;
      if (!card) return;
      e.preventDefault();
      openAssistant();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var card = e.target.closest ? e.target.closest('[data-ch-assistant]') : null;
      if (!card) return;
      e.preventDefault();
      openAssistant();
    });
  }

  function run(root) { initStatus(root); initHoursTable(root); initTodayCard(root); initWeather(root); bindFaqOnce(); bindAssistantOnce(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
  else run(document);

  // Theme Editor: re-init a section when it is (re)loaded
  document.addEventListener('shopify:section:load', function (e) {
    var box = e.target;
    if (box && box.querySelector && box.querySelector('.ch-status, .ch-hours, .ch-weather, .ch-faq__q')) run(box);
  });
})();
